import { render, staticRenderFns } from "./Banklist.vue?vue&type=template&id=5460d642&scoped=true"
import script from "./Banklist.vue?vue&type=script&lang=js"
export * from "./Banklist.vue?vue&type=script&lang=js"
import style0 from "./Banklist.vue?vue&type=style&index=0&id=5460d642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460d642",
  null
  
)

export default component.exports